import {Theme, ThemeSpec} from './types';

export const Themes: Record<Theme, ThemeSpec> = {
  [Theme.Funnels]: {
    cellBorders: `line`,
    cellBorderHover: `none`,
    cellFocusable: false,
    cellHeaderBorders: `column-group`,
    cellHeaderShadow: true,
    cellBackground: `focus-on-hover`,
    cellShape: `square`,
    rowGroups: false,
    rowHeight: 35,
  },
  [Theme.TrendData]: {
    cellBorders: `line`,
    cellBorderHover: `none`,
    cellFocusable: false,
    cellHeaderBorders: `column-group`,
    cellHeaderShadow: true,
    cellBackground: `focus-on-hover`,
    cellShape: `square`,
    rowGroups: false,
    rowHeight: 35,
  },
  [Theme.Retention]: {
    cellBorders: `gap`,
    cellBorderHover: `outline`,
    cellFocusable: true,
    cellHeaderBorders: `none`,
    cellHeaderShadow: false,
    cellBackground: `heatmap`,
    cellShape: `round`,
    rowGroups: false,
    rowHeight: 30,
  },
};
